import React, { useState, useEffect } from "react";
import { TextField, Grid, Paper, Button, Backdrop, CircularProgress, Alert } from '@mui/material';
import { makeStyles } from '@mui/styles';
import axios from 'axios';
import { getAuthenticationToken } from '../utils/TokenHandler';
import MaterialNotifyComponent from "./MaterialNotifyComponent";
import { withRouter } from 'react-router-dom';

function AddGiftCardForm(props) {
    const [messageNotify, setMessageNotify] = useState({ severity: "warning", message: "", open: false });
    const [open, setOpen] = useState(false);
    const [customeGiftCardCode, setCustomeGiftCardCode] = useState('');
    const [isRepresent, setIsRepresent] = useState(false);

    const useStyles = makeStyles(theme => ({
        root: {
            "& .MuiFormLabel-root": {
                right: 0, // or black
                left: 'unset'
            }, "& .MuiSvgIcon-root": {
                position: 'inherit'
            }
        }
    }));

    const classes = useStyles();
    const formElementStyle = {
        margin: "10px 0"
    };
    const paperStyle = {
        padding: 20,
        height: 'max-content',
        width: '70vw',
        margin: 'auto'
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setOpen(true);
        axios.post('/api/v1/Coupon/UseCoupon', {
            CustomerId: getAuthenticationToken().userID,
            Code: customeGiftCardCode
        }).then(response => {
            setMessageNotify({
                severity: response.data.success ? "success" : "warning",
                message: response.data.message,
                open: true
            });
        }).catch((e) => {
            setMessageNotify({
                severity: "error",
                message: "خطا در ثبت کارت هدیه",
                open: true
            });
        }).finally(() => {
            setOpen(false);
        });
    }
    const resultView = 
        <>
            <Alert variant="filled" severity="info" icon={false} style={{ marginBottom: '10px' }}>
                جهت ثبت اعتبار هدیه، کد مندرج در کارت هدیه را وارد نمائید
            </Alert>
            <form onSubmit={handleSubmit}>
                <Paper elevation={10} style={paperStyle} >
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <TextField
                                style={formElementStyle}
                                className={classes.root}
                                id="postalCode"
                                name="postalCode"
                                label="کد کارت هدیه"
                                fullWidth
                                variant="standard"
                                value={customeGiftCardCode}
                                onChange={e => setCustomeGiftCardCode(e.target.value)} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Button
                                id="submit"
                                type='submit'
                                name="submit"
                                fullWidth
                                variant="contained"
                                color="success" >ثبت کد کارت هدیه</Button>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Button
                                onClick={() => { props.history.push('/') }}
                                id="cancel"
                                name="cancel"
                                fullWidth
                                variant="outlined"
                                color="error" >انصراف</Button>
                        </Grid>
                    </Grid>
                </Paper>
            </form>
            <MaterialNotifyComponent onclose={() => { setMessageNotify({ ...messageNotify, open: false }) }} open={messageNotify.open} severity={messageNotify.severity} message={messageNotify.message} />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>

    return (
        resultView
    );
}

export default withRouter(AddGiftCardForm);